import { Swiper } from 'swiper/react';
import 'swiper/swiper.scss';

const Carousel = (props) => {
    return (
        <div className="container">
                <div className="row my-5 mx-lg-5">
                    <div className="col">
                        <h2>{props.carouselTitle}</h2>
                    </div>
                </div>
                <div className="row mx-lg-5">
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <Swiper
                                        breakpoints={{
                                        // when window width is >= 640px
                                        640: {
                                        slidesPerView: 3,
                                        },
                                        // when window width is >= 768px
                                        768: {
                                        slidesPerView: 4,
                                        },
                                    }}
                                    spaceBetween={20}
                                    slidesPerView={2}
                                >
                                    {props.content}
                                </Swiper>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    );
};

export default Carousel;
